import { render, staticRenderFns } from "./ProjectViewSidebarProgressCard.vue?vue&type=template&id=5ce59864&scoped=true"
import script from "./ProjectViewSidebarProgressCard.vue?vue&type=script&lang=ts"
export * from "./ProjectViewSidebarProgressCard.vue?vue&type=script&lang=ts"
import style0 from "./ProjectViewSidebarProgressCard.vue?vue&type=style&index=0&id=5ce59864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce59864",
  null
  
)

export default component.exports